import FusionCharts from "fusioncharts";

FusionCharts.options.license({
  key: 'ZbA1nuyD2C6F6G2C2E2F1C2A3A7B6C4xgaC2C5A5qB3D1F3dgrA4B8E2C-11xoG1D2G1lttE6E1C4G2D3B1B9B2B5D6D3kcA-7G2C9HE3sudC1G2B1A-21hD1CA2B4dfwB14B1D8D3D2B1C1A3G1A1A10B1D6E3o==',
  creditLabel: false,
});

export default function RegisterTheme() {
  FusionCharts.register('theme', {
    name: 'micad',
    theme: {
      pie3d: {
        chart: {
          paletteColors: '#201F7A,#4A47EB,#A3B8F5,#93A329,#C6D65C,#EAF5A3,#999999,#CCCCCC,#E6E6E6',
          bgAlpha: "0",
          borderAlpha: "0",
          showvalues: '0',
          showpercentintooltip: '0',
          manageLabelOverflow: '1',
          labelDistance: '20',
          showLabels: '0',
          showLegend: '1',
          interactiveLegend: '1',
          enableRotation: '1',
          use3DLighting: '1',
          showShadow: '1',
          animation: '1',
          pieSliceDepth: '20',
          pieYScale: '45',
          pieRadius: '140',
          enableSlicing: '0',
          legendBgColor: '#FFFFFF',
          legendBorderThickness: '0',
          legendShadow: '0',
          legendCaption: 'Legend',
          legendCaptionBold: '1',
          legendCaptionFont: 'Open Sans',
          legendCaptionFontSize: '9pt',
          legendSubcaptionFontSize: '8pt',
          // legendCaptionFontColor: '#333333',
          formatNumberScale: '0',
          legendCaptionAlignment: 'left',
          showZeroPies: '0',
          chartBottomMargin: '50'
        }
      },
      pie2d: {
        chart: {
          bgColor: "#ffffff",
//          paletteColors: '#003f5c,#444e86,#955196,#dd5182,#ff6e54,#ffa600',
          paletteColors: '#201F7A,#4A47EB,#A3B8F5,#93A329,#C6D65C,#EAF5A3,#999999,#CCCCCC,#E6E6E6',
          baseFont: "Arial",
          baseFontSize: "11",
          // baseFontColor: "#0066cc",
          borderAlpha: "0",
          showValues: "1",
          showlabels:"0",
          enableSmartLabels: "1",
          showLegend: "1",
          captionOnTop: "1",
          legendBgColor: '#ffffff',
          legendCaptionBold: '1',
          legendCaptionFontSize: '9pt',
          legendCaptionAlignment: 'left',
          legendBorderAlpha: "0",
          legendShadow: "0",
          legendIconScale: "1",
          plotHighlightEffect: "fadeout"
        }
      },
      line: {
        chart: {
          showValues: '0',
          bgAlpha: "0",
          borderAlpha: "0",
          showLabels: '0'
        }
      },
      msline: {
          chart: {
              showValues: '0',
              bgAlpha: "0",
              borderAlpha: "0",
              //showLabels: '1',
              //formatNumberScale: '0',
              axisLineAlpha: "5",
              divLineAlpha: "5",
              legendBorderAlpha: "0",
              legendShadow: "0",
          }
      },
      stackedbar2d: {
          chart: {
              usePlotGradientColor: "0",
              bgAlpha: "0"
          }
      },
      scrollstackedbar2d: {
          chart: {
              bgAlpha: "0",
              usePlotGradientColor: "0",
              labelDisplay: "ROTATE",
              slantLabels: "1",
              maxLabelWidthPercent: "15",
              legendBorderAlpha: "0",
              legendShadow: "0",
          }
      },
      scrollstackedcolumn2d: {
        chart: {
          paletteColors: '#201F7A,#4A47EB,#A3B8F5,#93A329,#C6D65C,#EAF5A3,#999999,#CCCCCC,#E6E6E6',
          bgAlpha: "0",
          borderAlpha: "0",
          flatscrollbars: "0",
          scrollHeight: "12",
          showValues: '0',
          showLabels: '1'
        }
      },
      mscombi2d: {
        chart: {
          paletteColors: '#201F7A,#4A47EB,#A3B8F5,#93A329,#C6D65C,#EAF5A3,#999999,#CCCCCC,#E6E6E6',
          bgAlpha: "0",
          borderAlpha: "0",
          showValues: '0'
        }
      },
      column2d: {
        chart: {
          paletteColors: '#201F7A,#4A47EB,#A3B8F5,#93A329,#C6D65C,#EAF5A3,#999999,#CCCCCC,#E6E6E6',
          bgAlpha: "0",
          borderAlpha: "0",
          showValues: '0'
        }
      },
      scrollarea2d: {
        chart: {
          formatnumberscale: "0",
          showValues: "0",
          drawcrossline: "1",
          flatScrollBars: "1",
          scrollheight: "10",
          usePlotGradientColor: "0",
          bgAlpha: "0",
          borderAlpha: "0",
          plottooltext: "$dataValue from $seriesName"
        }
      },

      hlineargauge: {
        chart: {
          showvalue: "1",
          bgAlpha: "0",
          borderAlpha: "0",
          baseFontColor: "#0066cc",
          //pointerhoverradius: "12",
          //showborderonhover: "1",
          //pointerborderhovercolor: "#333333",
          //pointerborderhoverthickness: "2",
          usePlotGradientColor: "0",
          showtickmarks: "1",
          numbersuffix: "%"
        }
      },

      angulargauge: {
        chart: {
          bgColor: "#ffffff",
          bgAlpha: "0",
          borderAlpha: "0",
          // baseFontColor: "#0066cc",
          setAdaptiveMin: "1",
          adjustTM: "1",
          tickvaluedistance: "10",
          placeTicksInside: "0",
          autoAlignTickValues: "1",
          showGaugeBorder: "0",
          minortmnumber: "0",
          majorTMHeight: "8",
          gaugeFillMix: "{light-0}",
          pivotbgcolor: "#000000",
          pivotfillmix: "0",
          showpivotborder: "1",
          pivotBorderColor: "#FFFFFF",
          showValue: "0",
          valueBelowPivot: "1"
        },
        dials: {
          dial: [{
            bgColor: "#000000",
            borderThickness: "0"
          }]
        }
      }

    }
  })
}
